// extracted by mini-css-extract-plugin
module.exports = {"titleWithLink":"feature-title-base-module--title-with-link--1Oute"};